import type { ValidationProblemDetails } from './types';

export default class BadRequestApiError extends Error {
  readonly errors: Record<string, string[]> | undefined;
  readonly activityErrors: Record<string, string[]> | undefined;

  constructor(details: ValidationProblemDetails) {
    super(details.title);
    this.name = 'BadRequestApiError';
    this.errors = details.errors;
    this.activityErrors = details.activityErrors;
  }
}
